import React, { useCallback, useMemo } from 'react';

// react router
import { useNavigate, useLocation } from 'react-router-dom';

// material-ui
import ArrowBack from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import { makeStyles, useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function LeadBackButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = useMemo(() => location.state || {}, [location.state]);

  const handleClick = useCallback(() => {
    if (state.fromPathname && state.fromPathname.includes('/leads'))
      navigate(-1);
    else navigate('/leads', { state });
  }, [navigate, state]);

  // Theme initializations
  const classes = useStyles();
  const theme = useTheme();
  const isSmallAndDown = useMediaQuery((theme as any).breakpoints.down('sm'));

  return (
    <Button
      size={isSmallAndDown ? 'medium' : 'large'}
      className={classes.container}
      startIcon={<ArrowBack />}
      onClick={handleClick}
    >
      Back To List
    </Button>
  );
}

const useStyles = makeStyles(theme => {
  return {
    container: {
      marginRight: 10,
      marginLeft: 10,
      [(theme as any).breakpoints.down('sm')]: {
        margin: 0,
      },
    },
  };
});
